
import { useEffect, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import Header from './Header';
import Footer from './Footer';

interface AppLayoutProps {
  children: ReactNode;
  wide?: boolean;
}

export default function AppLayout({ children, wide }: AppLayoutProps) {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && !user) {
      navigate('/login', { replace: true });
    } else if (!isLoading && user && !user.emailVerified) {
      navigate('/verify-email', { replace: true });
    }
  }, [user, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background-light dark:bg-background-dark flex items-center justify-center">
        <div className="flex items-center gap-2 text-primary">
          <span className="material-symbols-outlined text-3xl animate-spin">progress_activity</span>
          <span className="text-sm font-medium text-slate-500">Cargando...</span>
        </div>
      </div>
    );
  }

  if (!user) return null;

  return (
    <div className="bg-background-light dark:bg-background-dark min-h-screen flex flex-col">
      <Header />
      <main className={`${wide ? 'max-w-full' : 'max-w-7xl'} mx-auto px-4 sm:px-6 lg:px-8 py-8 flex-grow w-full flex flex-col`}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
